(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('StatoODGDeleteController',StatoODGDeleteController);

    StatoODGDeleteController.$inject = ['$uibModalInstance', 'entity', 'StatoODG'];

    function StatoODGDeleteController($uibModalInstance, entity, StatoODG) {
        var vm = this;

        vm.statoODG = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            StatoODG.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
